import { render } from "./RegistrationComponent.vue?vue&type=template&id=0a12e1b0&scoped=true"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js"

import "./RegistrationComponent.vue?vue&type=style&index=0&id=0a12e1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a12e1b0"]])

export default __exports__